import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FeedbackService } from "./feedback.service";
import { CoreLanguageService } from "../../services/language.service";
import { environment } from "../../../../environments/environment";
import { Location } from "@angular/common";
import { ContentType, SnackBarMessageType } from "../../shared/contentTypes";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { CoreCOMService } from "../../services/com.service";
import { ClientType } from "../../services/com/comEnvironmentClient";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { RatingDialogComponent } from "../../modalDialogs/ratingdialog/ratingDialog.component";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";

@Component({
  selector: "app-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["./feedback.component.scss"],
  providers: [FeedbackService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackComponent implements OnInit {

  public isMobile: boolean = false; // if it isn ot a mobile device, both link will open rating modal dialog
  public isSmallView: boolean = false;

  constructor(private _feedbackService: FeedbackService
    , private _coreLanguageService: CoreLanguageService
    , private _location: Location
    , private _coreCOMService: CoreCOMService
    , private snackBarService: SnackBarService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , _mainnavService: MainnavService) {
    this.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  ngOnInit(): void {
    const me = this;
    me.isMobile = me._coreCOMService.environment.client.isMobile;
  }

  public setFeedBackMessage() {
    const me = this;
    return (me._coreLanguageService.value("phFeedback_Message")).replace("<customer>", environment.CustomerName);
  }

  /**When small view is true, navigation back by swiping from left to right.*/
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me._location.back();
    }
  }

  /**
 * Open a ModalDialog to feedback Application
 */
  public openRateModel(): void {
    const me = this;
    // modal dialog Title
    const modalTitle = me._coreLanguageService.value("phFeedback_Modal_Title");
    const ratingModel = me._bottomSheetHelperService.open(RatingDialogComponent, {
      data: { contentType: ContentType.Feedback, title: modalTitle },
    });
    // show snackBar after rating Item
    ratingModel.afterDismissed().subscribe((result: any) => {
      if (result) {
        result
          .then(() => { me.snackBarService.ShowMessage(snackBarMessageKey.successfullyExecuted, SnackBarMessageType.Successful); })
          .catch(() => { me.snackBarService.ShowErrorMessageFailed(22); });
      }
    });
  }

  /**
   * opens GoogleStore or AppleStore (base on device) to vote application
   */
  public routeToAppVoting() {
    const me = this;
    if (me._coreCOMService.environment.client.type === ClientType.android) {
      // window.open("http://play.google.com/store/apps/details?id=my_package", "_system");
      window.open(environment.storeURL.GooglePlayStore, "_system");
    } else {
      window.open(environment.storeURL.AppleStore, "_system", "location=no");
    }
  }

}
